import { FC } from "react";
import Skeleton from "react-loading-skeleton";
import { BaseProps } from "../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { Shelf } from "../../layout";
import { Body } from "../../typography";
import styles from "./styles.module.scss";

/**
 * The `SharedCheckboxPlaceholder` component properties.
 */

export interface SharedCheckboxPlaceholderProps extends BaseProps {}

/**
 * A loading placeholder for the `SharedCheckbox` component.
 */
export const SharedCheckboxPlaceholder: FC<SharedCheckboxPlaceholderProps> = (props) => {
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.SharedCheckboxPlaceholder, "shared-checkbox", "placeholder"],
    testIdPrefix: "shared-checkbox",
  });

  return (
    <Body {...getBasePropsFromHtmlProps(baseHtmlProps)}>
      <Shelf spacing="small" alignment="top">
        <div className="check">
          <Skeleton />
        </div>
        <div className="label">
          <Skeleton />
        </div>
      </Shelf>
    </Body>
  );
};
